import React from 'react';
import styles from './styles.module.css';

// This is a screen to be used when a user is not active.
export const StopScreen: React.FC = () => {
  return (
    <div className={styles.container}>
      <h2>Account Inactive</h2>
      <div>
        You cannot access the Clearcover Agent Portal because your account is
        inactive. If you believe this is in error, please contact your
        administrator or email agents@clearcover.com.
      </div>
    </div>
  );
};
